<div class="sm:py-8">
  <div class="mt-4 xl:mx-14 inline-grid xl:absolute xl:inset-0 w-full justify-between xl:grid-cols-2 grid-cols-1 "
       style="">

    <div
      class="row-start-2 xl:row-auto xl:flex xl:flex-col xl:top-20 xl:!mt-0 mt-4 xl:absolute xl:left-0 xl:inset-y-0 xl:right-1/2">
      <input #searchInput (input)="searchEventsByName()" [(ngModel)]="searchValue"
             class=" block w-full rounded-md border-0 py-1.5  px-3 text-gray-900 ring-1 ring-inset ring-gray-300
             placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700
             sm:text-sm sm:leading-6 my-1"
             id="search" name="search"
             placeholder="Veranstaltung suchen..."
             type="text">
      <ul class="divide-y divide-gray-400 mt-8 xl:overflow-y-scroll xl:h-full">
        @for (event of filteredEvents; track event.id) {
          <li [queryParams]="{eventId: event.id}"
              [routerLink]="['/'+Routes.Analytics, {outlets:{analytics : [AnalyticsRouting.DetailedEventAnalysis]}}]"
              class="flex justify-between gap-x-6 py-3   sm:py-5 sm:px-4   hover:bg-gray-100 cursor-pointer">

            <div class="flex min-w-0 gap-x-4 ">
              <img alt=""
                   class="h-12 w-12 p-2  flex-none rounded-full bg-gray-700"
                   src="./assets/images/icon_nobackground_md.png">
              <div class="min-w-0 flex-auto">
                <p class="text-sm font-semibold leading-6 text-gray-900">{{ event.name }}</p>
                <p class="mt-1 truncate text-xs leading-5 text-gray-500">{{ event.id }}</p>
              </div>
            </div>
            <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
              <p class="text-sm leading-6 text-gray-900">
                Start: {{ event.start | date: globalDateService.getDateformat(GlobalDateFormat.LONG_WITH_TIME) }}</p>
              <p class="text-sm leading-6 text-gray-900">
                Ende: {{ event.end | date: globalDateService.getDateformat(GlobalDateFormat.LONG_WITH_TIME) }}</p>
            </div>
          </li>
        }
      </ul>
    </div>

    <div
      class="row-start-1
      xl:absolute xl:-translate-x-1/2 xl:left-3/4 xl:top-20 ">
      <!-- `w-full` (Tailwind), not `w-100` (Bootstrap `width:100%!important`) — Bug #234. The calendar's own
           stylesheet declares no host width, so nothing competes and the two are identical. -->
      <app-selectable-calendar #eventCalendar (daySelected)="daySelected($event)"
                               (monthChanged)="fetchVisibleDays($event)" [markedDates]="markedDates"
                               class=" sm:-mt-10 lg:row-auto flex w-full justify-center  mt-1"></app-selectable-calendar>
    </div>
  </div>
</div>


